'use es6';

import styled from 'foundations-theming/utils';
export default styled.div.withConfig({
  displayName: "DangerHandleButtonWrapper",
  componentId: "sc-1f0i6e1-0"
})([".hs-private.hs-private.hs-private & .uiButton.uiButton{background-color:", ";border:none;}.hs-private.hs-private.hs-private & .uiButton.uiButton:hover{background-color:", ";border:none;}"], ({
  theme
}) => theme.color['do-not-use-candy-apple'], ({
  theme
}) => theme.color['do-not-use-candy-apple-dark']);